import {remCalc} from '_themeUtils'

const loader = {
    Loader: {
        baseStyle: () => ({
            wrapper: {
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100dvw',
                height: '100dvh',
                alignItems: 'center',
                justifyContent: 'center',
                bg: 'color.background.loader.default',
                zIndex: 9999,
            },
            loader: {
                width: remCalc(150),
                height: 'auto',
            },
        }),
    },
}

export default loader
